import * as types from './actionsTypes';

const initialState = {
   loadData: 'idle',
   loadStamp: 'idle',
   customer: {},
   origin: {},
   invoice: {},
   //errors
   error: false,
   errorMessage: ''
};

function invoiceReducer(state, action) {
   switch (action.type) {
      //customer data
      case types.LOADING_DATA: {
         return {
            ...state,
            loadData: 'pending',
         }
      }
      case types.SUCCESSED_DATA: {
         return {
            ...state,
            loadData: 'resolved',
            customer: action.payload.data,
            origin: action.payload.origin
         }
      }
      case types.FAILED_DATA: {
         return {
            ...state,
            loadData: 'rejected',
            error: true,
            errorMessage: action.payload
         }
      }
      //invoice data
      case types.LOADING_STAMP: {
         return {
            ...state,
            loadStamp: 'pending',
         }
      }

      case types.SUCCESSED_STAMP: {
         return {
            ...state,
            loadStamp: 'resolved',
            invoice: action.payload
         }
      }

      case types.FAILED_STAMP: {
         return {
            ...state,
            loadStamp: 'rejected',
            error: true,
            errorMessage: action.payload
         }
      }

      case types.RESET_LOADED_DATA: {
         return {
            ...state,
            loadData: 'idle'
         }
      }

      case types.RESET_LOADED_STAMP: {
         return {
            ...state,
            loadStamp: 'idle'
         }
      }
      default:
         return state
   }
}


export {
   initialState,
   invoiceReducer,
}